<template>
  <section>
    <div class="pb-6">
      <GMap
        ref="gMap"
        language="en"
        :center="{lat: center.lat, lng: center.long}"
        :options="options"
        :zoom="zoom"
      >
        <GMapMarker
          v-for="begeleider in eligableBegeleiders"
          :key="begeleider.slug"
          :position="{lat: parseFloat(begeleider.latitude), lng: parseFloat(begeleider.longitude)}"
        >
          <GMapInfoWindow>
            <mentor-item :mentor="begeleider"/>
          </GMapInfoWindow>
        </GMapMarker>
      </GMap>
    </div>
  </section>
</template>

<script>
import MentorItem from '~/components/begeleiders/MentorItem';

export default {
  components: {MentorItem},
  props: {
    zoom: {
      type: Number,
      default: 7,
    },
    begeleiders: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      options: {
        fullscreenControl: false,
        zoomControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        scrollwheel: false,
      },
    };
  },
  computed: {
    eligableBegeleiders() {
      return this.begeleiders.filter(begeleider => begeleider.latitude && begeleider.longitude);
    },
    center() {
      return {
        lat: this.eligableBegeleiders.length ? parseFloat(this.eligableBegeleiders[0].latitude) : 52.100965,
        long: this.eligableBegeleiders.length ? parseFloat(this.eligableBegeleiders[0].longitude) : 5.646326,
      };
    },
  },
};
</script>

<style>
.GMap__Wrapper {
  height: 75vh;
}
</style>
